import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { APP_URL, COLORS, COMMON_EVENT, DIALOG_WIDTH, DROPDOWN_URL } from 'src/app/shared/constants';
import { CommonService } from 'src/app/services/common.service';
import { ICommonEvent } from 'src/app/interfaces/ICommon';
import { TextAvatarComponent } from 'src/app/shared/components/text-avatar/text-avatar.component';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NgScrollbarModule } from 'ngx-scrollbar';

import { Router, RouterModule } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ChangePasswordModalComponent } from '../change-password/change-password-modal.component';

@Component({
    selector: 'app-profile-dropdown',
    imports: [
    RouterModule,
    NgScrollbarModule,
    TablerIconsModule,
    MaterialModule,
    TranslateModule,
    TextAvatarComponent
],
    templateUrl: './profile-dropdown.component.html',
    styleUrls: ['./profile-dropdown.component.scss']
})

export class ProfileDropdownComponent implements OnInit {
  userName: string;
  profile: any = {
    link: DROPDOWN_URL.PROFILE
  }
  profileDrop: any[];

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private commonService: CommonService,
    public authService: AuthService) {
    this.updateUserName();
    this.commonService.commonObservable$.subscribe(({ id }: ICommonEvent) => {
      if (id === COMMON_EVENT.UPDATE_USER) {
        this.updateUserName();
      }
    });
  }

  ngOnInit(): void {
    this.initDropDown();
  }

  initDropDown() {
    this.profileDrop = [
      {
        icon: 'lock',
        title: 'change password',
        action: () => this.openModalChangePassword(),
      }
    ]
    const isAdmin = this.authService.loggerUser?.userRoles?.some((u: any) => u.role === 1);
    if (isAdmin) {
      const dropdownAdmin = {
        icon: "admin_panel_settings",
        title: 'administration',
        action: () => {
          return this.router.navigateByUrl(APP_URL.ADMIN_DASHBOARD);
        }
      }
      this.profileDrop.unshift(dropdownAdmin);
    }

    const defaultCompany = this.authService.loggerUser?.userRoles[0]?.company?.companyName;
    if (defaultCompany) {
      const dropdownCompany = {
        icon: "home",
        title: defaultCompany,
        action: () => {
          const companyId = this.authService.loggerUser?.userRoles[0]?.company?.id;
          return this.router.navigateByUrl(`${DROPDOWN_URL.COMPANY_INFO}/${companyId}`)
        }
      }
      this.profileDrop.unshift(dropdownCompany);
    }
  }

  private updateUserName() {
    this.userName = this.authService.loggerUser?.firstName && this.authService.loggerUser?.firstName ?
      `${this.authService.loggerUser?.firstName} ${this.authService.loggerUser?.lastName}` : '';
  }

  getAvatarStyles() {
    return {
      width: '48px',
      height: '48px',
      fontSize: '16px',
      backgroundColor: COLORS.AVATAR_BG,
      color: COLORS.AVATAR_TEXT
    };
  }

  getAvatarStylesHeader() {
    return {
      width: '35px',
      height: '35px',
      fontSize: '14px',
      backgroundColor: COLORS.AVATAR_BG,
      color: COLORS.AVATAR_TEXT
    };
  }

  logout() {
    this.authService.signOut();
    this.router.navigateByUrl("");
  }

  openModalChangePassword() {
    this.dialog.open(ChangePasswordModalComponent, {
      width: DIALOG_WIDTH.SMALL,
      autoFocus: false
    });
  }

  truncate(value: string, limit: number = 15, suffix: string = '...'): string {
    if (value && value.length > limit) {
      return value.substring(0, limit) + suffix;
    }
    return value;
  }
}
